<template>
<div>
  <div>
    <a-modal
      :footer="null"
      width="500px"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
    <div  class="modal_link">
      <div class="modal_tel"><img src='../../images/modal_tel.png'></div>
      <div class="modal_title">服务热线</div>
      <div class="modal_txt">如需咨询，请拨打服务热线</div>
      <div class="modal_tel_txt">010-50914766</div>
      <div class="modal_btn" >
        <div class="modal_btn_txt"  @click="handleOk">确定</div>
      </div>
      </div>
    </a-modal>
  </div>

</div>
  
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data(){
      return{
          top_show: false,
        // visible: false,
      }
  },
  methods: {
    handleOk() {
      // this.visible = false;
      this.$emit('onCloseModal', false)
    },
    handleCancel() {
      // this.visible = false;
      this.$emit('onCloseModal', false)
    },
 }
}
</script>

<style lang="scss" scoped>
.modal_link{
  height: 342px;
  text-align: center;
}
.modal_tel img{
    width: 40px;
    height: 40px;
    margin-top: 56px;
}
.modal_title{
  margin-top:13px;
  font-size:18px;
  font-weight: 500;
}
.modal_txt{
  margin-top:34px;
  font-size:18px;
  font-weight:400;
   color:#333333
}
.modal_tel_txt{
    margin-top:12px;
  font-size:18px;
  font-weight:400;
   color:#333333
}
.modal_btn_txt{
  margin: 0px auto;
   margin-top:48px;
   background: #F87942;
   color:#FFFEFE;
   font-size: 16px;
   text-align: center;
   width: 400px;
   height: 40px;
   line-height: 40px;
   border-radius: 30px;
   cursor: pointer;

}
// .top_me{
//   position: fixed;
//   right: 0px;
//   bottom: 20%;
// }
// .go_top, .link_me{
//   cursor: pointer;
//   width: 86px;
//   height: 86px;
//   box-shadow:0px 4px 18px 2px rgba(248,121,66,0.2);
//   color:#fff;
//   font-size: 16px;
//   font-weight:500;
//   text-align: center;
// }  
// .link_me{
//  background: #FD8753;
//  border-radius:8px 8px 0px 0px ;

// }
// .link_me img, .go_top img{
//   width: 42px;
//   height: 42px;
//   margin:10px 22px 7px;
// }
// .go_top{
//    background: #FF9B6F;
//    border-radius:0px 0px 8px 8px;
//    opacity:0.8;

// }
</style>